<template>
    <div class="main">
        <div class="body-content">
            <h3 style="margin: 0;">Shipping Bills</h3>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <v-select :clearable="false" tabindex="0" placeholder="Select Party Name" id="partyname"
                        v-model="newContainer.partyName" :options="party" label="short_name"
                        :reduce="party => party.autoid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="vcnname">VCN No *</label>
                    <v-select :clearable="false" id="vcnname" v-model="newContainer.vcnID" :options="vcns"
                        @v-on:change="FillVCNDetails" label="vcnName" :reduce="vcn => vcn.vcnID" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="vesselName">Vessel *</label>
                    <v-select :clearable="false" id="vesselName" placeholder="Select Vessel"
                        v-model="newContainer.vesselID" ref="vesselName" :options="vessel" label="Name"
                        :reduce="vessel => vessel.Vesselid" selectOnTab="True" />
                </div>

                <div class="form-item">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage"
                        label="Name" :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="location">Location:</label>
                    <v-select :clearable="false" id="location" v-model="newContainer.locID" :options="location"
                        label="Name" :reduce="location => location.locationid" selectOnTab="True" />
                </div>
                <div class="form-item" style="width: 10%;">
                    <label for="fromdate">From Date </label>
                    <input type="text" id="fromdate" v-model="newContainer.fromdate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsDate()" style="width: 100px;" />
                </div>
                <div class="form-item" style="width: 10%;">
                    <label for="todate">To Date </label>
                    <input type="text" id="todate" v-model="newContainer.todate" placeholder="dd/mm/yyyy"
                        v-on:blur="checkIsToDate()" style="width: 100px;" />
                </div>
            </div>
            <div class="form-group">
                <div class="form-item" style="width: 90%;">
                    <label for="contnumber">container's:</label>
                    <textarea id="contnumber" style="width: 100%;" v-model="newContainer.contnumber"
                        placeholder="Generating Report for Specific Container(s)..." rows="3"></textarea>
                </div>
            </div>
            <div class="form-group">
                <div class="form-item" style="margin-top: 15px;">
                    <button type="button" class="excel-button" @click="getTablesData" :disabled="isSubmitting">Show</button>
                </div>
            </div>

            <div class="form-group" v-if="rows.length > 0">
                <div class="form-item-inline" style="display: flex; align-items: center; gap: 8px;">
                    <label for="searchbox" style="white-space: nowrap; margin: 0;">Search:</label>
                    <input id="searchbox" type="text" v-model="searchQuery" placeholder="Search any field..." style="flex: 1; min-width: 180px;" />
                </div>
                <div class="form-item" style="width: 100%;">                
                    <RevoGrid hide-attribution :source="displayedRows" :columns="columns" :theme="compact"
                        @afteredit="onCellEdit" @cell-custom-action="onGridCellAction" />
                </div>
            </div>
            <div v-if="showNewContainerModal" class="modal-overlay">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>Add New Container</h3>
                        <button class="close-btn" @click="closeNewContainerModal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <strong>Shipping Bill:</strong> {{ selectedRowForNewContainer?.sbno }}
                        </div>
                        <div class="form-row2">
                            <div>
                                <label>Container No</label>
                                <input v-model="newContainerModal.contnumber" placeholder="Container Number" />
                            </div>
                            <div>
                                <label>SEAL NO</label>
                                <input v-model="newContainerModal.seal" placeholder="SEAL NO" />
                            </div>
                        </div>
                        <div class="form-row2">
                            <div>
                                <label>No Of Packages</label>
                                <input v-model="newContainerModal.no_of_package" placeholder="Number of Packages" />
                            </div>
                            <div>
                                <label>Type Of Package</label>
                                <input v-model="newContainerModal.type_of_package" placeholder="Type Of Package" />
                            </div>
                        </div>
                        <div class="form-row2">
                            <div>
                                <label>Gross Weight</label>
                                <input v-model="newContainerModal.gross_wt" placeholder="Gross Weight" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="cancel-button" @click="closeNewContainerModal">Cancel</button>
                        <button class="excel-button" @click="saveNewContainer">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { h } from 'vue';
import { useToast } from 'vue-toastification';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import * as cs from '../assets/js/commonscript.js'
import RevoGrid, { VGridVueTemplate } from '@revolist/vue3-datagrid'

const NewContainerCell = {
    props: ['model'],
    render() {
        return h('button', {
            type: 'button',
            class: 'open-container-cell-btn',
            style: {
                display: 'inline-block',
                marginBottom: '2px',
                backgroundColor: '#0dcaf0',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px',
                height: '25px'
            },
            onClick: (e) => {
                e.currentTarget.dispatchEvent(new CustomEvent('cell-custom-action', {
                    bubbles: true,
                    detail: { row: this.model, action: 'open-new-container' }
                }));
                e.stopPropagation();
            }
        }, 'New Container');
    }
};

export default {
    components: {
        VSelect,
        RevoGrid,
    },
    data() {
        return {
            party: JSON.parse(localStorage.getItem('party')),
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            location: JSON.parse(localStorage.getItem('Area')) || [],
            vcns: [],
            columns: [
                { prop: 'sno', name: 'S.No' },
                { prop: 'bookingno', name: 'Booking No', sortable: true },
                { prop: 'sbno', name: 'Shipping Bill', sortable: true },
                { prop: 'sbdate', name: 'SB Date', sortable: true },
                {
                    prop: 'contnumber', name: 'Container', sortable: true, size: 110,
                    cellProperties: ({ model }) => {
                        return {
                            style: {
                                color: model.contnumberInvalid ? 'red' : ''
                            },
                        }
                    }
                },
                { prop: 'action', name: 'New Container', size: 140, cellTemplate: VGridVueTemplate(NewContainerCell), sortable: false },
                { prop: 'iec', name: 'IEC' },
                { prop: 'gstn', name: 'GSTN', size: 120 },
                { prop: 'pcin', name: 'PCIN', size: 150 },
                { prop: 'type_of_package', name: 'Type Of Package' },
                { prop: 'no_of_package', name: 'No On Package' },

            ],
            rows: [],
            searchQuery: '',
            isSubmitting: false,
            showNewContainerModal: false,
            selectedRowForNewContainer: null,
            newContainerModal: {
                contnumber: '',
                seal: '',
                no_of_package: '',
                type_of_package: '',
                gross_wt: ''
            },
            newContainer: {
                partyName: 0,
                applicantID: 0,
                accountID: 0,
                vesselID: 0,
                vesselname: '',
                consign: '',
                vcnID: 0,
                VoyId: 0,
                voyage: '',
                locID: 0,
                contnumber: '',
                fromdate: '',
                todate: ''
            }
        }
    },
    created() {
        this.fetchVcnList();
    },
    watch: {
        'newContainer.vcnID'(value) {
            this.FillVCNDetails(value)
        }
    },
    methods: {
        checkIsDate() {
            if (this.newContainer.fromdate != '') {
                if (cs.isvalidDate(this.newContainer.fromdate) == false) {
                    useToast().error('Invalid From Date');
                }
            }
        },
        checkIsToDate() {
            if (this.newContainer.todate != '') {
                if (cs.isvalidDate(this.newContainer.todate) == false) {
                    useToast().error('Invalid To Date');
                }
            }
        },
        async fetchVcnList() {
            const token = localStorage.getItem('access_token');
            try {
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const response = await axios.get('/active_vcn_list/', config);
                var data = response.data[2]
                data.push({ "vcnID": 0, "vcnName": "Select VCN", "vesselID": 0, "import_voyage": 0, "export_voyage": 0, "MlocID": 0, "ImpRotNo": "", "ImpRotDate": null, "ExpRotNo": "", "ExpRotDate": null, "BerthDate": null, "EgmDate": null, "SailDate": null, "IsSail": 0, "vesselLocation": 0, "created_by": 0, "CreateDate": null, "last_modified_by": 0, "ModiDate": null, "VesselName": "", "import_voyageName": "", "export_voyageName": "", "area": "", "Vesselarea": "" })
                this.vcns = data;
            } catch (error) {
                console.error('Error fetching VCN list:', error);
                this.error = 'Error fetching VCN list. Check console for details.';
            }
        },
        FillVCNDetails(value) {
            //const vcnID = this.newContainer.vcnID
            const selvcn = this.vcns.find(vcn => vcn.vcnID === value);
            if (selvcn.vcnID !== 0) {
                if (selvcn) {
                    this.newContainer.vesselID = selvcn.vesselID
                    this.newContainer.VoyId = selvcn.export_voyage
                    this.newContainer.voyage = selvcn.export_voyageName
                    this.newContainer.locID = selvcn.MlocID
                }
            }
        },
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.accountID = AppAcc.accountid
        },
        async getTablesData() {
            if (this.isSubmitting) return;
            
            if ((this.newContainer.partyName === 0 || this.newContainer.vesselID === 0 || this.newContainer.VoyId === 0) && this.newContainer.contnumber === '' && (this.newContainer.fromdate === '' || this.newContainer.todate === '')) {
                {
                    useToast().error("Please fill all required fields");
                    return;
                }
            }
            
            this.isSubmitting = true;
            try {
                if (this.newContainer.partyName !== 0) {
                    this.updateApplicantAccountIds(this.newContainer.partyName)
                }
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                        'Content-Type': 'multipart/form-data'
                    },
                };
                const data = new FormData();
                const transdt = JSON.stringify(this.newContainer)
                data.append('transaction', transdt)
                const response = await axios.post(`/sb_uploadedlist`, data, config);
                console.log(response)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                    this.rows = [];
                    return;
                } else {
                    useToast().success("Data fetched successfully");
                    //this.rows = response.data[2];
                    const regex = /^[A-Za-z]{4}\d{7}$/;
                    this.rows = response.data[2].map((row, idx) => ({
                        sno: idx + 1,
                        ...row,
                        contnumberInvalid: !regex.test(row.contnumber) // Add a flag for invalid container
                    }));
                    //console.log(this.rows)
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                useToast().error('An error occurred while fetching data');
                this.rows = [];
            } finally {
                this.isSubmitting = false;
            }
        },
        async onCellEdit(event) {
            try {
                var { model, prop, val, row } = event.detail;
                //console.log(model, prop, val);
                //console.log('Row not found or invalid:', model, prop);
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                        'Content-Type': 'multipart/form-data'
                    },
                };
                const data = new FormData();
                var modeldata = model
                modeldata.prop = prop;
                var transdt = JSON.stringify(model)
                console.log(transdt)
                data.append('prop', prop);
                data.append('transaction', transdt)
                const response = await axios.post('/update_sb', data, config);
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success("Updated successfully");
                }
                // Find the index in the underlying rows array (in case the grid is filtered)
                const idx = this.rows.findIndex(r => (r.sno === model.sno && r.sbno === model.sbno));
                const targetIndex = idx !== -1 ? idx : row;
                if (prop === 'contnumber') {
                    const regex = /^[A-Za-z]{4}\d{7}$/;
                    const updatedRow = {
                        ...this.rows[targetIndex],
                        [prop]: val,
                        contnumberInvalid: !regex.test(val)
                    };
                    this.rows.splice(targetIndex, 1, updatedRow);
                } else {
                    // For other props, update the underlying row as well
                    const updatedRow = {
                        ...this.rows[targetIndex],
                        [prop]: val
                    };
                    this.rows.splice(targetIndex, 1, updatedRow);
                }
            } catch (error) {
                console.error('Error updating cell:', error);
                useToast().error('An error occurred while updating the cell');
            }
        },
        onGridCellAction(event) {
            const action = event.detail?.action;
            const row = event.detail?.row;
            if (action === 'open-new-container') {
                this.selectedRowForNewContainer = row;
                this.newContainerModal = {
                    contnumber: '',
                    seal: '',
                    no_of_package: '',
                    type_of_package: '',
                    gross_wt: ''
                };
                this.showNewContainerModal = true;
            }
        },
        closeNewContainerModal() {
            this.showNewContainerModal = false;
            this.selectedRowForNewContainer = null;
        },
        async saveNewContainer() {
            try {
                if(this.newContainerModal.contnumber === '' || this.newContainerModal.no_of_package === '' || this.newContainerModal.type_of_package === '') {
                    useToast().error('Please fill all fields in the new container form');
                    return;
                }
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                };
                const data = new FormData();
                const payload = {
                    sbno: this.selectedRowForNewContainer.sbno,
                    contnumber: this.newContainerModal.contnumber,
                    seal: this.newContainerModal.seal,
                    no_of_package: this.newContainerModal.no_of_package,
                    type_of_package: this.newContainerModal.type_of_package,
                    gross_wt: this.newContainerModal.gross_wt
                };
                const transdt = JSON.stringify(payload)
                data.append('transaction', transdt);

                const response = await axios.post('/save_new_leo_container', data, config);
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success("New container saved successfully");
                }
            } catch (error) {
                console.error('Error saving new container:', error);
                useToast().error('An error occurred while saving the new container');
            }
        },
    }
    ,
    computed: {
        displayedRows() {
            const q = (this.searchQuery || '').toString().trim().toLowerCase();
            if (!q) return this.rows;
            return this.rows.filter(row => {
                return Object.values(row).some(val => {
                    if (val === null || val === undefined) return false;
                    return String(val).toLowerCase().includes(q);
                });
            });
        }
    }
}
</script>
<style scoped>
.invalid-contnumber {
    background-color: #ffcccc !important;
}

.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 30%;
}

.form-item1 {
    width: 90%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
}

.open-container-cell-btn {
    background-color: #0dcaf0 !important;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 12px;
}

.open-container-cell-btn:hover {
    background-color: #0bb3db !important;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: min(560px, 95%);
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.2);
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
}

.modal-header h3 {
    margin: 0;
    font-size: 18px;
}

.close-btn {
    background: transparent;
    border: none;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
}

.modal-body {
    display: grid;
    gap: 12px;
    margin-bottom: 15px;
}

.form-row {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.form-row2 {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}

.form-row label,
.form-row2 label {
    font-weight: 600;
    font-size: 13px;
}

.form-row input,
.form-row2 input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}
</style>